import intlMessagesEN from './i18n/localization/en.json';
import intlMessagesVi from './i18n/localization/vi.json';

export default {
  name: 'Wedding',
  dir: 'Wedding',
  pathRoot: '',
  routes: [
    {
      url: 'thong-tin-dam-cuoi',
      component: 'Page/index',
      meta: {
        authRoute: true,
      },
      layout: 'FullLayout',
      props: {
        title: 'Thiệp cưới | Smart Event',
        titleI18n: 'Wedding:title',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: 'info-bride-groom',
      component: 'Page/InfoBrideGroom',
      meta: {
        authRoute: true,
      },
      layout: 'FullLayout',
      props: {
        title: 'Thiệp cưới | Smart Event',
        titleI18n: 'Wedding:title',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: 'setup-dam-cuoi',
      component: 'Page/SetupPage',
      meta: {
        authRoute: true,
      },
      layout: 'FullLayout',
      props: {
        title: 'Thiệp cưới | Smart Event',
        titleI18n: 'Wedding:title',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: 'wedding-card',
      component: 'Page/InfoWeddingCard',
      meta: {
        authRoute: true,
      },
      layout: 'FullLayout',
      props: {
        title: 'Thiệp cưới | Smart Event',
        titleI18n: 'Wedding:title',
        headerStyle: 'fill',
        exact: true,
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: true,
};
